import React, { Component } from 'react'
import { connect } from 'react-redux'
import trans, { isTrans } from "trans"

import { css, Grid, GridCell, Theme, Button, Icon, Div, Link } from "@bdfx/mergado-ui-kit"

import { initForm, updateInputValue as change } from "app/reducers/form"
import { ACTIVE_VIEW_EDIT_EFFECTS, ACTIVE_VIEW_EDIT_SOURCE_IMAGE, ACTIVE_VIEW_NEW_SHAPE, ActiveViewType } from "../containers/Editor";

import { nextIndex, prevIndex, redoHistory, TemplateOrAlternativeTemplateType, undoHistory, UndoRedoHistory } from "../undoRedoReducers";
import { getDateToday } from "app/helpers/other";
import { RandomProduct } from "shape-edit/types";
import PreviewModal from "./preview-modal";
import { IconAddLayer, IconDices, IconGrid } from "app/icons";
import { setActiveGroupId, setActiveView } from "shape-edit/reducers";

import {
    createGroupFromSelected,
    getFormName,
    getGridStepSize,
    getTemplateSize,
    GRID_MODES_COUNT,
    rotateSelectedShapes,
    SOURCE_IMAGE_INDEX
} from "shape-edit/forms/helpers";

import { selectLayers } from "shape-list/reducers";
import { EditModeType, GuidesType, ID } from "app/types/app-types";
import { setEditMode, setGuides } from "actions";
import { CoordsType } from "shape-entities/components/shape";
import { BrushFormType, Project, Template } from "app/types/model-types";
import { ZOOM_STEP } from "../containers/image-preview";
import { selectFormValues } from 'app/reducers/form';
import { RENDERED_TYPE_ANIM_GIF } from 'products/types';
import { BRUSH_TYPE, NO_TEXT_CURSOR_TYPES } from 'shape-entities/types/shape'
import { find, omitBy } from 'lodash'
import { LevelsModeType } from './save-template-form'
import { testUsers } from './helper'

const {round} = Math

interface Props {
    templateId: ID
    altTemplateId: ID
    levels: string[]
    levelsMode: LevelsModeType
    isAlt: boolean
    templateForm: Template
    form: TemplateOrAlternativeTemplateType
    activeShapeId: string
    activeGroupId: string
    undoHistory: Function
    redoHistory: Function
    activeView: ActiveViewType
    project: Project
    editMode: EditModeType
    change: Function
    handleImageRefresh: Function
    sameImageInPreview: boolean
    isSaved: boolean
    toggleSameImageInPreview: Function
    undoRedoHistory: UndoRedoHistory
    brushForm: BrushFormType
    randomProduct: RandomProduct
    guides: GuidesType
    selectedLayers: string[]
    lockedLayers: string[]
    updateZoom: Function
    updateTranslate: Function
    canvasZoom: number
    canvasTranslate: CoordsType
    isLoading: boolean
    selectLayers: typeof selectLayers
    setActiveGroupId: typeof setActiveGroupId
    setGuides: typeof setGuides
    setActiveView: typeof setActiveView
    setEditMode: typeof setEditMode
    initForm: typeof initForm
}

interface State {
    current: number
}

export const iconSize = 22
export const iconColor = Theme.blue
export const iconDisabledColor = '#a3a3a3'

class ToolsPanel extends Component<Props, State> {

    constructor(props) {
        super(props);

        this.state = {
            current: null,
        }
    }

    componentDidMount(): void {
        console.debug('calling handle image refresh from tools panel, preferred product id is', this.props.templateForm.random_product_id)
        this.props.handleImageRefresh(true, this.props.templateForm.random_product_id)
    }

    render() {
        const {
            undoRedoHistory, form, brushForm, randomProduct, activeShapeId, activeGroupId, activeView,
            selectedLayers, guides, canvasZoom, canvasTranslate, isLoading, isAlt, project, editMode,
            lockedLayers
        } = this.props

        const formName = getFormName(isAlt)

        const nextIdx = nextIndex(undoRedoHistory.index)
        const prevIdx = prevIndex(undoRedoHistory.index)

        const nextData = undoRedoHistory.buffer[nextIdx]
        const prevData = undoRedoHistory.buffer[prevIdx]

        const dateNow = getDateToday()
        const activeFrom = form.active_from ? new Date(form.active_from) : null
        const activeTo = form.active_to ? new Date(form.active_to) : null
        const isActiveNow = ((!activeFrom || (activeFrom <= dateNow)) && (!activeTo || (activeTo >= dateNow)))

        const activeShape = activeShapeId ? form.shapes[activeShapeId] : null
        const activeGroup = activeGroupId ? find(form.groups, (g) => {
            return g.index === activeGroupId
        }) : null

        /*const isGroupSelected = (selectedLayers.length !== activeGroup.list.length && _intersection(activeGroup.list, selectedLayers).length === activeGroup.list.length)*/

        const isLocked = activeShapeId && lockedLayers.includes(activeShapeId)
        const isEditable = (activeShapeId && activeView !== ACTIVE_VIEW_EDIT_SOURCE_IMAGE && !isLocked)
        const isBrush = isEditable && activeShape && activeShape.type === BRUSH_TYPE
        const color = !isEditable ? iconDisabledColor : Theme.blue
        const userId = project && project.user && project.user.id ? project.user.id : null

        const templateSize = getTemplateSize()

        return <Style className="tiny-scrollbar">
            <GridCell>

                <StyledPanelGrid cols="40px" gap={"10px"}>
                    <StyledCell className={'above-undo-redo'}>
                        <Button
                            color="nocolor"
                            size="tiny"
                            title={trans('add_shape_button')}
                            icon={<IconAddLayer size={iconSize} />}
                            onClick={() => this.props.setActiveView(ACTIVE_VIEW_NEW_SHAPE)}
                        />

                        {selectedLayers.length > 1 &&
                            <Button
                                title={trans(selectedLayers.length > 1 && !activeGroup ? 'create_layer_group' : (activeGroup ? 'delete_layer_group' : 'create_layer_group'))}
                                color="nocolor"
                                size="tiny"
                                icon={<Icon type={selectedLayers.length > 1 && !activeGroup ? 'object-group' : 'object-ungroup'} size={iconSize} color={selectedLayers && selectedLayers.length > 1 || activeGroup ? Theme.blue : iconDisabledColor} />}
                                onClick={() => {
                                    if (selectedLayers.length > 1 && !activeGroup) {
                                        createGroupFromSelected()
                                    } else if (activeGroup) {
                                        const newGroups = form.groups.filter(g => g.index !== activeGroup.index)
                                        this.props.selectLayers(activeGroup.list)
                                        this.props.setActiveGroupId(null)
                                        this.props.change(formName, 'groups', newGroups)
                                    }
                                }}
                            />
                        }
                    </StyledCell>

                    <StyledCell style={{ position: 'relative' }}>
                        <Button
                            color="nocolor"
                            size="tiny"
                            title={trans(guides.isShowGrid ? 'toggle_snap_to_grid' : 'toggle_snap_to_element')}
                            icon={<Icon type={'magnet'} size={iconSize} color={!guides.isSnapOn ? iconDisabledColor : Theme.blue} />}
                            onClick={() => {
                                this.props.setGuides({
                                    ...guides,
                                    isSnapOn: !guides.isSnapOn,
                                    isShowGuides: !guides.isSnapOn
                                })
                            }}
                        />
                        <Button
                            color="nocolor"
                            size="tiny"
                            title={trans('show_grid')}
                            style={{ background: !guides.isShowGrid ? '#fff' : `${Theme.blue} !important` }}
                            icon={<IconGrid size={iconSize} color={!guides.isShowGrid ? Theme.blue : '#fff'} gridStepMode={guides.gridStepMode} />}
                            onClick={() => {
                                const nextGridStepMode = (guides.gridStepMode + 1) % GRID_MODES_COUNT
                                this.props.setGuides({
                                    ...guides,
                                    isShowGrid: nextGridStepMode > 0,
                                    gridStep: getGridStepSize(templateSize.width, templateSize.height, nextGridStepMode),
                                    gridStepMode: nextGridStepMode,
                                })
                            }}
                        />
                        <Button
                            color="nocolor"
                            size="tiny"
                            title={isLoading && isTrans(`template_type_${form.type}`) ? trans(`template_type_${form.type}`) : trans('random_product')}
                            icon={randomProduct.isLoading ? <Icon type={'spinner'} size={iconSize} color={iconDisabledColor} /> :
                                isLoading ? <Icon type={'magic'} size={iconSize} color={iconDisabledColor} /> :
                                    <IconDices size={iconSize} color={iconColor} />}
                            onClick={(e) => this.props.handleImageRefresh()}
                        />

                        <PreviewModal
                            sameImageInPreview={this.props.sameImageInPreview}
                            handleImageRefresh={this.props.handleImageRefresh}
                            templateId={this.props.templateId}
                            altTemplateId={this.props.altTemplateId}
                            levels={this.props.levels}
                            levelsMode={this.props.levelsMode}
                        />

                    </StyledCell>

                    {isEditable ?
                        <StyledCell>
                            <Button
                                color="nocolor"
                                size="tiny"
                                title={trans('vertical_align_center')}
                                icon={<Icon type={'arrows-h'} size={iconSize} color={color} />}
                                disabled={!isEditable}
                                onClick={() => {
                                    if (!activeShapeId || activeShapeId === 'sourceImage') {
                                        this.props.change(formName, 'translate_x', 0)
                                    } else {
                                        this.props.change(formName, `shapes.${activeShapeId}.x`, round(templateSize.width / 2))
                                    }
                                }}
                            />
                            <Button
                                color="nocolor"
                                title={trans('horizontal_align_center')}
                                size="tiny"
                                icon={<Icon type={'arrows-v'} size={iconSize} color={color} />}
                                disabled={!isEditable}
                                onClick={() => {
                                    if (!activeShapeId || activeShapeId === 'sourceImage') {
                                        this.props.change(formName, 'translate_y', 0)
                                    } else {
                                        this.props.change(formName, `shapes.${activeShapeId}.y`, round(templateSize.height / 2))
                                    }
                                }}
                            />

                            <Button
                                color="nocolor"
                                size="tiny"
                                title={trans('rotate_right')}
                                icon={<Icon type={'rotate-left'} size={iconSize} color={selectedLayers.length > 0 ? Theme.blue : color} />}
                                disabled={!isEditable && selectedLayers.length < 1}
                                onClick={() => {
                                    if (!activeShapeId) {
                                        this.props.change(formName, 'rotation', ((form.rotation || 0) + 90) % 360)
                                    } else if (selectedLayers.length > 0 && !activeShapeId) {
                                        rotateSelectedShapes(10)
                                    } else if (activeShape) {
                                        this.props.change(formName, `shapes.${activeShapeId}.angle`, ((activeShape.angle || 0) + 10) % 360)
                                    }
                                }}
                                style={{ transform: 'scaleX(-1)' }}
                            />

                            <Button
                                color="nocolor"
                                size="tiny"
                                title={trans('rotate_left')}
                                icon={<Icon type={'rotate-left'} size={iconSize} color={selectedLayers.length > 0 ? Theme.blue : color} />}
                                disabled={!isEditable && selectedLayers.length < 1}
                                onClick={() => {
                                    if (!activeShapeId) {
                                        this.props.change(formName, 'rotation', ((form.rotation || 0) - 90) % 360)
                                    } else if (selectedLayers.length > 0 && !activeShapeId) {
                                        rotateSelectedShapes(-10)
                                    } else if (activeShape) {
                                        this.props.change(formName, `shapes.${activeShapeId}.angle`, ((activeShape.angle || 0) - 10) % 360)
                                    }
                                }}
                            />

                            <Button
                                color="nocolor"
                                size="tiny"
                                title={trans('horizontal_flip')}
                                icon={<Icon type={'flip-horizontal'} size={iconSize} color={color} />}
                                disabled={!isEditable}
                                onClick={() => {
                                    if (!activeShapeId) {
                                        this.props.change(formName, 'flop', +!form.flop)
                                    } else {
                                        this.props.change(formName, `shapes.${activeShapeId}.is_flop`, !activeShape.is_flop)
                                    }
                                }}
                            />
                            <Button
                                color="nocolor"
                                size="tiny"
                                title={trans('vertical_flip')}
                                icon={<Icon type={'flip-vertical'} size={iconSize} color={color} />}
                                disabled={!isEditable}
                                onClick={() => {
                                    if (!activeShapeId) {
                                        this.props.change(formName, 'flip', +!form.flip)
                                    } else {
                                        this.props.change(formName, `shapes.${activeShapeId}.is_flip`, !activeShape.is_flip)

                                    }
                                }}
                            />
                        </StyledCell>
                        : null}

                    {isBrush &&
                        <StyledCell>
                            <Button
                                title={trans('brush')}
                                color="nocolor"
                                size="tiny"
                                icon={<Icon type={'paint-brush'} size={iconSize} color={!brushForm.is_eraser ? Theme.blue : iconDisabledColor} />}
                                onClick={() => {
                                    this.props.change("brushForm", "is_eraser", !brushForm.is_eraser)
                                }}
                            />

                            {activeShape.brush_strokes &&
                                <Button
                                    title={trans('eraser')}
                                    color="nocolor"
                                    size="tiny"
                                    icon={<Icon type={'eraser-radix'} size={iconSize} color={brushForm.is_eraser ? Theme.blue : iconDisabledColor} />}
                                    onClick={() => {
                                        this.props.change("brushForm", "is_eraser", !brushForm.is_eraser)
                                    }}
                                />
                            }
                        </StyledCell>
                    }

                    {!!(isEditable && activeShapeId && activeShapeId !== SOURCE_IMAGE_INDEX) &&
                        <StyledCell background={Theme.red} >
                            <Button
                                size="tiny"
                                simple={true}
                                icon={<Icon type={'trash-o'} size={"20"} style={{ lineHeight: "30px" }} color={"white"} />}
                                // disabled={!activeShapeId}
                                onClick={() => {
                                    const shapes = { ...form.shapes }
                                    const newShapes = omitBy(shapes, (value, key) => key === activeShapeId)    //form.shapes[activeShapeId].index
                                    this.props.change(formName, "shapes", newShapes)
                                }}
                            />
                        </StyledCell>
                    }

                    <StyledTopPanel>
                        <Grid className={'top-panel-grid'}>
                            <Div class={'left-cell'} />
                            <Div class={'zoom-cell'}>
                                <GridCell
                                    title={trans('zoom_in')}
                                    className='white-bg'
                                    style={{
                                        opacity: 0.3,
                                        ":hover": {
                                            opacity: 1,
                                        },
                                        pointerEvents: 'auto'
                                    }}>
                                    <Button
                                        color="nocolor"
                                        size="tiny"
                                        title={trans('format_original').toLowerCase()}
                                        icon={<Icon
                                            type={'search-light'}
                                            size={"15"}
                                            text={`${(round(canvasZoom * 100) / 100).toFixed(2)}×`} color={((canvasZoom !== 1 || !canvasTranslate || canvasTranslate.x !== 0 || canvasTranslate.y !== 0)) ? Theme.blue : iconDisabledColor}
                                        />}
                                        onClick={() => {
                                            this.props.updateZoom(1)
                                            this.props.updateTranslate({ x: 0, y: 0 })
                                        }}
                                        style={{
                                            borderRight: "1px solid #ddd",
                                            borderRadius: 0,
                                        }}
                                    />
                                    <Button
                                        color="nocolor"
                                        size="tiny"
                                        title={trans('zoom_in')}
                                        icon={<Icon type={'plus-light'} size={"13"} color={Theme.blue} />}
                                        onClick={() => this.props.updateZoom(canvasZoom + ZOOM_STEP)}
                                    />
                                    <Button
                                        color="nocolor"
                                        size="tiny"
                                        title={trans('zoom_out')}
                                        icon={<Icon type={'minus-light'} size={"13"} color={Theme.blue} />}
                                        onClick={() => this.props.updateZoom(canvasZoom - ZOOM_STEP)}
                                    />
                                </GridCell>
                            </Div>

                            <GridCell className={'right-cell'} align="right" valign="top">
                                <GridCell style={{ display: "inline-block", verticalAlign: "top", marginRight: "20px", pointerEvents: 'auto' }}>
                                    <Grid cols="auto auto 12px auto">
                                        {/* TODO:  */}
                                        {(testUsers.includes(userId) && activeShape && !NO_TEXT_CURSOR_TYPES.includes(activeShape.type)) ?
                                            <Button
                                                color="nocolor"
                                                size="tiny"
                                                title={trans('toggle_auto_grow')}
                                                className='some-users-only'
                                                icon={<Icon type={'maximise-light'} size={18} color={!guides.isAutoGrowOn ? iconDisabledColor : Theme.blue} />}
                                                onClick={() => {
                                                    this.props.setGuides({
                                                        ...guides,
                                                        isAutoGrowOn: !guides.isAutoGrowOn,
                                                    })
                                                }}
                                                style={{
                                                    padding: '5px 7px',
                                                    marginRight: '6px',
                                                    boxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
                                                    backgroundColor: '#fff',
                                                }}
                                            /> :
                                            <GridCell />
                                        }

                                        {(testUsers.includes(userId) && activeShape && !NO_TEXT_CURSOR_TYPES.includes(activeShape.type)) ?
                                            <Button
                                                color="nocolor"
                                                size="tiny"
                                                title={trans('text_mode')}
                                                className='some-users-only'
                                                icon={<Icon type={editMode === 'text' ? 'i-cursor' : 'cursor-light'} size={18} color={Theme.blue} />}
                                                onClick={() => {
                                                    if (editMode === 'select') {
                                                        this.props.setEditMode('text')
                                                    } else {
                                                        this.props.setEditMode('select')
                                                    }
                                                }}
                                                style={{
                                                    padding: '5px 7px',
                                                    boxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
                                                    backgroundColor: '#fff',
                                                }}
                                            /> :
                                            <GridCell />
                                        }

                                        <GridCell />

                                        <GridCell className='white-bg'>
                                            <Button
                                                color="nocolor"
                                                size="tiny"
                                                icon={<Icon type={'undo-light'} size={18} color={!prevData ? iconDisabledColor : Theme.blue} />}
                                                disabled={!prevData}
                                                onClick={() => {
                                                    if (!!prevData) {
                                                        this.props.initForm(formName, prevData)
                                                        this.props.undoHistory()
                                                    }
                                                }}
                                                style={{
                                                    borderRadius: 0,
                                                    borderRight: "1px solid #ddd"
                                                }}
                                            />
                                            <Button
                                                color="nocolor"
                                                size="tiny"
                                                icon={<Icon type={'redo-light'} size={18} color={!nextData ? iconDisabledColor : Theme.blue} />}
                                                disabled={!nextData}
                                                onClick={() => {
                                                    if (!!nextData) {
                                                        this.props.initForm(formName, nextData)
                                                        this.props.redoHistory()
                                                    }
                                                }}
                                            />
                                        </GridCell>
                                    </Grid>
                                </GridCell>
                            </GridCell>
                            <Div />
                        </Grid>
                    </StyledTopPanel>
                </StyledPanelGrid>
            </GridCell>
        </Style>
    }
}

const Style = css("div")({
    overflowY: "auto",
    minWidth: "50px",
    padding: "5px",
})

const ZoomIcon = css(Icon)({
    ' .muk-icon__text': {
        margin: '0 !important',
    }
})

const StyledPanelGrid = css(Grid)({
    borderRadius: '3px solid gray',
    textAlign: 'center',
    alignSelf: 'center',
    ' .white-bg': {
        boxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
        backgroundColor: '#fff',
        whiteSpace: "nowrap",
        ' .muk-icon__text': {
            margin: '0 !important',
            verticalAlign: "middle",
            fontWeight: "normal",
            fontSize: "11px",
        },
        borderRadius: "5px",
        overflow: "hidden",
        ".muk-button": {
            padding: "5px 10px",
        },
    }
})

export const StyledCell = css(GridCell)(props => ({
    position: 'relative',
    width: '100%',
    minHeight: '100%',
    /*zIndex: 2000,*/   /*image preview is 2000*/
    backgroundColor: props.background ?? '#fff',
    overflow: 'hidden',
    textAlign: 'center',
    alignSelf: 'center',
    cursor: 'pointer',
    borderRadius: '3px',
    ' button': {
        width: '36px',
        height: '36px',
        marginBottom: "0px",
        ':active': {
            background: 'transparent',
        },
        ':focus': {
            background: 'transparent',
        },
    },
    ".muk-button + .muk-button": {
        borderTop: "1px solid #ddd",
        borderRadius: 0,
    },
    ' .muk-icon--add-layer svg': {
        width: '25px',
        height: '100%',
    },
    ' .muk-icon--dices svg': {
        width: '25px',
        height: '100%',
    },
    boxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
    webkitBoxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
    mozBoxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
}))

const StyledTopPanel = css('div')({
    position: 'fixed',
    top: '92px',
    left: 0,
    right: 0,
    margin: 'auto',
    zIndex: 100,
    pointerEvents: 'none',
    ' .top-panel-grid': {
        gridTemplateColumns: '1fr auto 1fr minmax(440px, 32%)',
        gridGap: '5px',
    },
    '@media screen and (max-width: 800px)': {
        top: '45px',
        gridGap: '15px',
        ' .muk-icon--magic-stars .muk-icon__text': {
            display: 'none',
            visibility: 'hidden',
        },
        ' .top-panel-grid': {
            gridTemplateColumns: '45px max-content max-content auto',
        },
    },
})

const StyledIconStars = css(Icon)({
    /*background: '#ffffff6e',*/
    background: `radial-gradient(#ffffff, #ffffff00) !important`,
    borderRadius: '20px',
    paddingRight: '10px',
})

function mapStateToProps(state) {

    return {
        activeShapeId: state.activeShapeId,
        activeGroupId: state.activeGroupId,
        activeView: state.activeView,
        isAlt: state.isAlt,
        templateForm: selectFormValues(state, 'templateForm'),
        form: selectFormValues(state, getFormName(state.isAlt)),
        brushForm: selectFormValues(state, 'brushForm'),
        randomProduct: state.randomProduct,
        undoRedoHistory: state.undoRedoHistory,
        selectedLayers: state.selectedLayers,
        lockedLayers: state.lockedLayers,
        guides: state.guides,
        project: state.project.data,
        editMode: state.editMode,
    }
}

export default connect(mapStateToProps, {
    initForm,
    undoHistory,
    redoHistory,
    setActiveView,
    setEditMode,
    selectLayers,
    setGuides,
    setActiveGroupId,
    change,
})(ToolsPanel)